import { render } from "./addgk.vue?vue&type=template&id=2ac6e0f1"
import script from "./addgk.vue?vue&type=script&lang=js"
export * from "./addgk.vue?vue&type=script&lang=js"

import "./addgk.vue?vue&type=style&index=0&id=2ac6e0f1&lang=scss"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__